import { BUYER_SETTINGS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/buyer_settings_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState, 'email');
